import { render, staticRenderFns } from "./AssetTranscribe.vue?vue&type=template&id=1ec76fcd&"
import script from "./AssetTranscribe.vue?vue&type=script&lang=js&"
export * from "./AssetTranscribe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports